/*
Author: Chathuraka Mallawa Arachchi
Date: 18/10/2024
Copyright © 2024 Infix!. All rights reserved.

Responsible for form applying validations based on question type
*/


import {Actions,AdvancedMultiChoiceCheckbox,DateRangeMatrixType,informationPackName,MultiChoiceCheckbox,QuestionTextOnly,RepeatableMatrix, SingleSelect} from "@/constants/constants"
import {AnswerValueTypes,BasicAnswerSave, InformationPack, OutsideQuestionnaireAnswerSave} from "@/state/survey/saveAnswerSlice"
import answerDetails from "../abstract/answerDetails"
import {DateRangeType,FormState} from "../types/commonTypes"
import {INode} from "../types/nodeTypes"

const poaAnswerDetails = (function () {

    const generateQuestionAnswerSubmitFormatFromValue = (value: unknown | AnswerValueTypes, node: INode,): BasicAnswerSave []=> {
        switch(node.type){
            case DateRangeMatrixType :{
                const answers : BasicAnswerSave[] = []
                let answerValues:  DateRangeType[] = []
                if(value && typeof value === 'string' ) {
                    answerValues = JSON.parse(value as string)
                }
 
                const answerObject: BasicAnswerSave = {
                    name: node.name,
                    value: answerValues as DateRangeType[]
                }
                answers.push(answerObject)
                return answers;

            }
            case QuestionTextOnly: {
                return answerDetails.setNameAndValueFromDirectValue(node, value);
            }
            case RepeatableMatrix:
            case MultiChoiceCheckbox:
            case AdvancedMultiChoiceCheckbox: {
                const answers : BasicAnswerSave[] = []
                const answerValues = JSON.parse(value as string)
                const answerObject: BasicAnswerSave = {
                    name: node.name,
                    value: answerValues
                }
                answers.push(answerObject)
                return answers;
            }
            default:{
                return answerDetails.setNameAndValueFromDirectValue(node, value);
            }       
        }
    }

    const generateQuestionAnswerSubmitFormat = (form: FormState, node: INode,): BasicAnswerSave []=> {
        switch(node.type){
            case DateRangeMatrixType :{
                const answers : BasicAnswerSave[] = []
                let answerValues:  DateRangeType[] = []
                if(form[node.name] && form[node.name]?.value && typeof form[node.name]?.value === 'string' ) {
                    answerValues = JSON.parse(form[node.name]?.value as string)
                }
 
                const answerObject: BasicAnswerSave = {
                    name: node.name,
                    value: answerValues as DateRangeType[]
                }
                answers.push(answerObject)
                return answers;

            }
            case QuestionTextOnly: {
                return answerDetails.setNameAndValue(node, form);
            }
            case RepeatableMatrix:
            case  Actions: {
                const answers : BasicAnswerSave[] = []
                const answerValues = JSON.parse(form[node.name]?.value as string)
                const answerObject: BasicAnswerSave = {
                    name: node.name,
                    value: answerValues
                }
                answers.push(answerObject)
                return answers;
            }   
            case MultiChoiceCheckbox:    
            case AdvancedMultiChoiceCheckbox: {
                const answers : BasicAnswerSave[] = []
                const answerValues = JSON.parse(form[node.name]?.value as string)
                const answerObject: BasicAnswerSave = {
                    name: node.name,
                    value: answerValues
                }
                answers.push(answerObject)
                return answers;
            }
            default:{
                return answerDetails.setNameAndValue(node, form);
            }       
        }
    }

    const generateOutsideQuestionnaireAnswerSubmitFormat = (form: FormState, node: INode, informationPacks?:InformationPack[]): OutsideQuestionnaireAnswerSave[] | null => {
        switch(node.type){
            case SingleSelect :{
                const selectedValue = form[informationPackName];
                const selectedPack = (informationPacks as InformationPack[]).find(informationPack => informationPack.title === selectedValue.value);
                if(!selectedPack?.id){
                    return null;
                }
                const answerSubmit:OutsideQuestionnaireAnswerSave[] = []
                const answerObject : OutsideQuestionnaireAnswerSave = {
                    op: "replace",
                    path:'/InformationPackId',
                    value: selectedPack!.id 
                }
                answerSubmit.push(answerObject)
                return answerSubmit;
            }
            default:{
                return null;
            }       
        }
    }
    return {
        generateQuestionAnswerSubmitFormat,
        generateQuestionAnswerSubmitFormatFromValue,
        generateOutsideQuestionnaireAnswerSubmitFormat
    }
})()

export default poaAnswerDetails
